import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import objectPath from 'object-path';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBack';
import BreadCrumbs from './components/BreadCrumbs';
import { LayoutContextConsumer } from '../LayoutContext';
import * as builder from '../../ducks/builder';
import ButtonAddProduct from '../../../app/components/ui/Buttons/ButtonAddProduct';
import { makeStyles } from '@material-ui/core';
import {useIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';
import { IAppState } from '../../../app/store/rootDuck';

const useStyles = makeStyles(theme => ({
  cartText: {
    color: theme.palette.secondary.main,
    maxWidth: 350,
    [theme.breakpoints.down(768)]: {
      maxWidth: '100%',
    },
  },
  container: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    [theme.breakpoints.down(768)]: {
      flexDirection: 'column',
    },
  },
  autoLoc: {
    width: '100%',
  },
  cartBtn: {
    marginLeft: 40,
    marginRight: 20,
    minWidth: 310,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    justifyContent: 'flex-end',
    [theme.breakpoints.down(768)]: {
      marginLeft: 0,
    },
  },
  wrapSearch: {
    fontWeight: 700,
    width: '100%',
    display: 'flex',
    flex: 1,
    maxWidth: 'calc(100% - 326px - 30px)',
    minWidth: 'calc(326px)',
    [theme.breakpoints.down(768)]: {
      maxWidth: '100%',
      minWidth: '100%',
    },
  },
}));

const SubHeader = () => {
  const classes = useStyles();
  const intl = useIntl();
  const [anchorEl, setAnchorEl] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleClose = () => Boolean(false);

  const {
    subheaderContainerCssClasses,
    subheaderCssClasses,
    subheaderMobileToggle,
  } = useSelector((store: IAppState) => ({
    subheaderMobileToggle: objectPath.get(
      store.builder.layoutConfig,
      'subheader.mobile-toggle'
    ),
    subheaderCssClasses: builder.selectors.getClasses(store, {
      path: 'subheader',
      toString: true,
    }),
    subheaderContainerCssClasses: builder.selectors.getClasses(store, {
      path: 'subheader_container',
      toString: true,
    }),
  }));

  const { me } = useSelector((store: IAppState) => ({
    me: store.profile.me,
  }));

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <LayoutContextConsumer>
      {({
        subheader: {
          title,
          breadcrumb,
          description,
          show,
          onPress,
          btnTitle,
          back,
          btnAddCart,
          textBtnAddCart,
        },
      }: any) =>
        show && (
          <div style={{ backgroundColor: '#fff' }}>
            <div
              id='kt_subheader'
              className={`kt-subheader ${subheaderCssClasses} kt-grid__item`}
              style={{ margin: '0 auto', width: '100%', maxWidth: 1490 }}
            >
              <div className={`kt-container ${subheaderContainerCssClasses} `}>
                <div className='kt-subheader__main '>
                  <>
                    {subheaderMobileToggle && (
                      <button
                        className='kt-subheader__mobile-toggle kt-subheader__mobile-toggle--left'
                        id='kt_subheader_mobile_toggle'
                      >
                        <span />
                      </button>
                    )}

                    <div className='kt-subheader__wrap-left'>
                      {back && (
                        <div
                          className='kt-subheader__left-icon-container'
                          onClick={() => navigate(-1)}
                        >
                          <ArrowBackIosIcon style={{ width: 20, height: 20 }} />
                        </div>
                      )}
                      {breadcrumb && (
                        <BreadCrumbs items={breadcrumb} hideBreadcrumbIcon={false} />
                      )}
                      {title && description && (
                        <span className='kt-subheader__separator kt-subheader__separator--v' />
                      )}

                      {btnTitle && (
                        <h3
                          onClick={onPress}
                          className='kt-subheader__title'
                          style={{ fontWeight: 600, color: '#293B85', cursor: 'pointer' }}
                        >
                          {btnTitle}
                        </h3>
                      )}

                      {textBtnAddCart && (
                        <h3
                          onClick={btnAddCart}
                          className='kt-subheader__title'
                          style={{ fontWeight: 600, color: '#293B85', cursor: 'pointer' }}
                        >
                          {textBtnAddCart}
                        </h3>
                      )}

                      {location.pathname === '/products/catalog' && (
                        <>
                          <ButtonAddProduct />
                        </>
                      )}
                    </div>
                    <div className={classes.container}>
                    </div>
                    {description && <span className='kt-subheader__desc'>{description}</span>}
                  </>
                </div>
              </div>
            </div>
          </div>
        )
      }
    </LayoutContextConsumer>
  );
};

export default SubHeader;
